import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './About.css';

const SKILL_TAGS = [
  'Python', 'SQL', 'Tableau', 'Snowflake', 'XGBoost',
  'Docker', 'React', 'Django', 'FastAPI', 'Next.js',
  'Whisper', 'Shopify', 'n8n', 'Tailscale', 'Linux', 'Excel/VBA'
];

function About() {
  const { t } = useTranslation();

  const paragraphKeys = ['about.p1', 'about.p2', 'about.p3'];

  return (
    <section id="about" className="about">
      <div className="about-text">
        <h2 className="about-title">
          <Trans
            i18nKey="about.heading"
            components={{ em: <em /> }}
          />
        </h2>

        {paragraphKeys.map((k) => (
          <p key={k}>{t(k)}</p>
        ))}

        <div className="skill-tags">
          {SKILL_TAGS.map(s => (
            <span key={s} className="skill-tag">{s}</span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
